import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=6847%3A20207
 *
 * @param {SvgIconProps} props - svg props
 */
export const DocumentIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M6 1.5C4.89543 1.5 4 2.39543 4 3.5V20.5C4 21.6046 4.89543 22.5 6 22.5H18C19.1046 22.5 20 21.6046 20 20.5V7.91421C20 7.649 19.8946 7.39464 19.7071 7.20711L14.2929 1.79289C14.1054 1.60536 13.851 1.5 13.5858 1.5H6ZM19 8.5L13 2.5V7.5C13 8.05228 13.4477 8.5 14 8.5H19Z' fill={color}/>
        </SvgIcon>
    )
}

export default DocumentIcon
